import { computed, Ref, unref } from 'vue';
import { skipToken, useQuery } from '@tanstack/vue-query';
import { fetchVulnerability } from './vulnerability.endpoints';
import { TFetchVulnerabilityPayload } from '../models/types';

export function useFetchVulnerability(payloadRef: Ref<TFetchVulnerabilityPayload | null>) {
  const query = useQuery({
    queryKey: computed(() => {
      const payload = unref(payloadRef);
      return ['vulnerability', payload?.uid];
    }),
    queryFn: computed(() => {
      const payload = unref(payloadRef);
      if (!payload) return skipToken;

      return () => fetchVulnerability(payload);
    }),
  });

  return query;
}
